import React from "react";

export default function PageShell({ children }) {
  return <div className="page">{children}</div>;
}
